/* eslint-disable prettier/prettier */
const actions = {
  async listPaymentToInsurerTransaction(context, payload) {
    try {
      const fetchParameters = {
        params: {
          insurerCode: context.getters["getSelectedInsurer"]?.code || "ALL",
        },
        ...payload,
      };
      const response = await this.$api.call(
        "finops_payment_to_insurer_transaction.list",
        fetchParameters,
      );
      if (response.data === null) {
        response.data = [];
      }
      const responseData = response.data;

      if (typeof payload.tab !== "undefined" && payload.tab !== null) {
        context.commit("mutationPaymentToInsurerTransactionList", {
          responseData,
          tab: payload.tab,
        });
      } else {
        context.commit("mutationPaymentToInsurerTransactionList", responseData);
      }

      context.commit("mutationFetchParameter", fetchParameters);
      context.commit("mutationPaymentToInsurerTransactionMeta", response.meta);

      return response;
    } catch (error) {
      context.commit("mutationPaymentToInsurerTransactionList", []);
      context.commit("mutationPaymentToInsurerTransactionMeta", {});

      throw error;
    }
  },

  async listInsurerBranch(context, payload) {
    try {
      const response = await this.$api.call(
        "finops_payment_to_insurer_transaction.insurance_branch_list",
        payload,
      );

      if (response.data === null) {
        response.data = [];
      }

      const responseData = response.data;

      context.commit("mutationInsurerBranchList", responseData);

      return responseData;
    } catch (error) {
      context.commit("mutationInsurerBranchList", []);

      throw error;
    }
  },

  setSelectedInsurer(context, payload = "ALL") {
    context.commit("mutationSelectedInsurer", payload || { code: "ALL" });
  },

  setFetchParameter(context, payload = {}) {
    context.commit("mutationFetchParameter", payload || {});
  },

  async downloadListPaymentToInsurerTransaction(context) {
    try {
      const fetchParameters = context.getters["getFetchParameter"];
      const response = await this.$api.call(
        "finops_payment_to_insurer_transaction.download",
        fetchParameters,
      );
      return response;
    } catch (error) {
      throw error;
    }
  },
};

export default actions;
